import { Card } from 'antd'
import styled from 'styled-components'

interface StyledTreeNodeProps {
  colorPrimary: string
}

const StyledTreeNode = styled(Card)<StyledTreeNodeProps>`
  &.company {
    background-color: #ecf6ff;
  }
  &.dimension {
    background-color: #fffded;
  }
  &.function {
    background-color: #faedff;
  }
  &.leaf {
    margin-left: 4px;
    /* border: 1px solid ${props => props.colorPrimary}; */
    &::before {
      content: '';
      position: absolute;
      left: -5px; /* Position to the left of the node */
      top: 50%; /* Center vertically */
      transform: translateY(-50%); /* Adjust for vertical centering */
      width: 3px; /* Width of the marker */
      height: 100%;
      background-color: ${props => props.colorPrimary}; /* Match the border color */
      border-radius: 2px; /* Make it a circle */
    }
  }
  &.error {
    border: 1px solid red;
  }
  &:hover {
    border: 1px solid ${props => (props.colorPrimary ? `${props.colorPrimary}60` : '#4a90e280')};
  }
`

export default StyledTreeNode
